import React, {Component} from 'react';
import localDb from '@util/localDb';
import {queryIncuOregistappInfo} from '@api/incubator/oregistapp';
import {queryIncuOregistappMoveOutInfo} from '@api/incubator/oregistappMoveOut';

import PageEdit from './PageEdit';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    // const { type } = this.props.params;
    // if (type === "regist") {
    //   this.getIncuOregistappInfo();
    // } else if (type === "moveOut") {
    //   this.getIncuOregistappMoveOutInfo();
    // }
    this.getInfo();
  }

  getInfo = () => {
    const { type } = this.props.params;
    if (type === 'regist') {
      this.getIncuOregistappInfo();
    } else if (type === 'moveOut') {
      this.getIncuOregistappMoveOutInfo();
    }
  };

  getIncuOregistappInfo = () => {
    queryIncuOregistappInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        res.data.instance = res.data.moveOutInstance;
        res.data.histories = res.data.moveOutHistories;
        res.data.createUser = res.data.moveOutCreateUser;
        this.setState({
          dataInfo: res.data,
        });
        return true;
      }
      return false;
    });
  };

  getIncuOregistappMoveOutInfo = () => {
    queryIncuOregistappMoveOutInfo({
        uuid: this.props.params.uuid,
      })
      .then(res => {
        if (res.statusCode === 200) {
          res.data.updateDate = res.data.instance.updateDate;
          res.data.instance = res.data.moveOutInstance;
          res.data.histories = res.data.moveOutHistories;
          res.data.createUser = res.data.moveOutCreateUser;
          this.setState({
            dataInfo: res.data,
          });
          return true;
        }
        return false;
      });
  };

  render() {
    const { dataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit data={dataInfo} {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} {...this.props} getInfo={this.getInfo} />;
    }
    return <span />;
  }
}
export default PageInfo;



// WEBPACK FOOTER //
// ./src/components/incubator/oregistappMoveOut/PageInfo.js